module.exports = __webpack_public_path__ + "img/auburn-tourism.b7df19e5.jpg";